import type { ListContext, RecipeSummary } from '@platewell/query';
import { listContextParams, useFormatTag, useIsFavourite } from '@platewell/query';
import { Link } from '@tanstack/react-router';
import { FavouriteBadge } from './favourite-button.js';
import { Photo } from './photo.js';

export function RecipeCard({
  recipe,
  context,
}: {
  recipe: RecipeSummary;
  /** The list this card sits in, carried onto the recipe so it can page and get back. */
  context?: ListContext | null;
}) {
  const formatTag = useFormatTag();
  const isFavourited = useIsFavourite(recipe.id);
  return (
    <Link
      className="card"
      to="/recipes/$recipeId"
      params={{ recipeId: recipe.id }}
      search={context == null ? {} : listContextParams(context)}
    >
      <div className="card-photo-wrap">
        <Photo className="card-photo" blobId={recipe.primaryBlobId} alt="" size={400} />
        {isFavourited && <FavouriteBadge />}
      </div>
      <div className="card-body">
        <span className="card-title">{recipe.title}</span>
        <span className="card-meta">
          {recipe.totalMinutes != null && <span>{formatMinutes(recipe.totalMinutes)}</span>}
          {recipe.tags.slice(0, 2).map((tag) => (
            <span className="tag" key={tag}>
              {formatTag(tag)}
            </span>
          ))}
        </span>
      </div>
    </Link>
  );
}

export function formatMinutes(total: number): string {
  if (total < 60) return `${total} min`;
  const hours = Math.floor(total / 60);
  const minutes = total % 60;
  return minutes === 0 ? `${hours} hr` : `${hours} hr ${minutes} min`;
}
